import React from "react";
import TextareaAutosize from "react-textarea-autosize";
import {FormFeedback, Label, FormGroup, Col} from 'reactstrap';

const TextAreaInput = ({
    id,
    name,
    description,
    placeholder,
    value,
    onChange,
    errors,
    required
}) => {
    return (
        <FormGroup row className="mb-2">
            <Label md={4} className="pr-md-1">{description} {!!required && '*'}</Label>
            <Col md={8}>
                <TextareaAutosize
                    onChange={(e) =>
                        onChange(id, {
                            [e.target.name]: e.target.value
                        })
                    }
                    className={`form-control ${!!errors ? ' is-invalid ' : ''}`}
                    value={value ?? ""}
                    placeholder={placeholder || description}
                    name={name}
                    minRows={2}
                />
                {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
            </Col>
        </FormGroup>
    );
};

export default TextAreaInput
